<div *ngIf="!_loading" class="flex-column gap-L">
	<div class="font-MM fw-700">{{ 'page.workstation.users'|translate }}</div>
	<div class="flex-column gap-M">
		@for (user of workstationUsers; track user.userId) {
			<div class="user-card pad-M flex-align-center gap-M">
				<div class="user-icon-bubble flex-center">
					<img src="assets/icons/userss.svg" class="filter-accent">
				</div>
				<div class="flex-column gap-XS">
					<span class="fw-700 font-M">
						{{ user.userRealName || '-' }}
					</span>
					<span class="font-S">
						{{ user.team && user.structure ? user.structure!.name + ' - ' + user.team!.name : user.structure?.name || user.team?.name || '-' }}
					</span>
				</div>
			</div>
		} @empty {

		}
	</div>
</div>
<app-dashboard-page-loader *ngIf="_loading"></app-dashboard-page-loader>

